// Shared
export const HD_URL = 'https://www.homedepot.com';
export const APPENDED_BRAND_NAME = ' - The Home Depot';
export const OPEN_GRAPH_FACEBOOK_ADMIN = '100005416960152';
export const IMAGE_REGEX = /\.(gif|jpe?g|tiff|png)(\?.*)?$/i;
export const ANDROID_HREF = 'android-app://com.thehomedepot/homedepot/';
export const SCHEMA_CTX = 'https://schema.org';
export const HD_LOGO = 'https://dam.thdstatic.com/content/production/eP5kyjsulp9WvllgCzFqDg/'
  + 'CB9wmCIvrHY3yzogvPa8qA/Original%20file/TheHomeDepot%20Logo.png?im=Resize=(256,256)';

// Article Metadata
export const ARTICLE_BUYING_GUIDE_REGEX = /ab/i;
export const ARTICLE_INSPIRATION_GUIDE_REGEX = /ai/i;
export const ARTICLE_PROJECT_GUIDE_REGEX = /ah/i;
export const ARTICLE_INFLUENCER_GUIDE_REGEX = /ap/i;
export const ARTICLE_LISTING_PAGE_REGEX = /alp/i;

// Product Metadata
export const IMAGE_SIZE_REGEX = /_\d+./gm;
export const IMAGE_SIZE_URL_PARAM_REGEX = /_<SIZE>./g;

// Store Pages
export const SD_OG_IMAGE = 'https://assets.thdstatic.com/mcstore/images/hero-200x155.jpg';
export const HD_URL_L = 'https://www.homedepot.com/l/';
export const REVIEWS_PAGE_SIZE = 30;

export const PAGE_TYPE = {
  DETAILS: 'details',
  REVIEWS: 'reviews',
  HOME_SERVICES: 'services',
  RENTALS: 'rentals',
  GARDEN_CENTER: 'garden-center',
  PRO_DESK: 'pro-desk'
};

export const LAST_PATH = {
  DETAILS: '',
  HOME_SERVICES: '/services',
  RENTALS: '/rentals',
  GARDEN_CENTER: '/garden-center',
  REVIEWS: '/reviews',
  PRO_DESK: '/pro-desk'
};

export const EMT_PAGE_NAMES = {
  DETAILS: 'storeDetails',
  HOME_SERVICES: 'homeServices',
  RENTALS: 'rentals',
  GARDEN_CENTER: 'gardenCenter',
  REVIEWS: 'storeReviews',
  LOCAL_CITY: 'lcp',
  PRO_DESK: 'proDesk',
  ARTICLES: 'articles',
  PPR: 'ppr',
  PPQ: 'ppq',
  LONGTAIL: 'longtail',
  PIP: 'pip'
};

// Store Locator Metadata
export const STORE_LOCATOR_DESCRIPTION = 'Find The Home Depot location closest to you with our store locator.'
  + ' You\'ll save time and money at The Home Depot near you.';

// Product Reviews Metadata
export const DEFAULT_REVIEWS_SORT_BY = 'photoreview';

export const GOOGLE_SITE_VERIFICATION_ID = 'hTruuR2TVS4eMD0TGLDoDuakN349R8VQToGMKnh1Ago';

export const DEFAULT_ALTERNATE_LINKS = [
  { href: `${HD_URL}`, hreflang: 'en' },
  { href: `${HD_URL}/`, hreflang: 'x-default' },
  { href: 'https://www.homedepot.ca/en/home.html/', hreflang: 'en-ca' },
  { href: 'https://www.homedepot.ca/fr/accueil.html', hreflang: 'fr-ca' },
  { href: 'https://www.homedepot.com.mx/', hreflang: 'es-mx' }
];

// Bros
export const MAX_PRELOAD_PRODUCT_IMAGES = 4;
export const MAX_PRELOAD_PRODUCT_IMAGES_MOBILE = 2;
